// Una clave de idempotencia por INTENTO. Reintentar el MISMO pedido (mismo cuerpo) tras una falla de
// red reusa la clave: si el primero sí llegó, el backend devuelve el mismo resultado en vez de crear
// otra nota o confirmar dos veces. Un error de dominio, en cambio, cierra el intento: la próxima vez
// (quizá ya hay stock) es otro intento con otra clave. El frontend NO reemplaza la protección del
// backend: solo la usa bien.
import { useCallback, useRef } from 'react';
import { ErrorApi, nuevaClaveIdempotencia } from './cliente';

interface Intento {
  accion: string;
  cuerpo: string;
  clave: string;
}

export function useIntentos() {
  const ultimo = useRef<Intento | null>(null);

  const clave = useCallback((accion: string, cuerpo: unknown): string => {
    const c = JSON.stringify(cuerpo ?? null);
    const u = ultimo.current;
    if (u && u.accion === accion && u.cuerpo === c) return u.clave;
    const nueva = nuevaClaveIdempotencia(accion);
    ultimo.current = { accion, cuerpo: c, clave: nueva };
    return nueva;
  }, []);

  /** Tras el resultado: se conserva la clave SOLO si no se sabe si el pedido llegó (red o 5xx). */
  const cerrar = useCallback((error?: unknown) => {
    const incierto = error instanceof ErrorApi && (error.status === 0 || error.status >= 500);
    if (!incierto) ultimo.current = null;
  }, []);

  return { clave, cerrar };
}
